import React from 'react';
import { useTranslation } from 'react-i18next';
import type { Milestone } from '../types';

export default function PaidMilestoneNotice({ milestone }: { milestone: Milestone }) {
  const { t } = useTranslation();
  const previous = milestone.previousPayment;
  if (!previous) return null;
  const format = (ore: number) => new Intl.NumberFormat('sv-SE', { style: 'currency', currency: 'SEK', maximumFractionDigits: 2 }).format(ore / 100);
  return <div className="small text-success mt-2" data-testid="paid-milestone-notice">
    <i className="feather-check-circle me-1" aria-hidden="true" />
    {t('contractReplacement.paidMilestone', { number: milestone.milestoneNumber, contract: previous.contractNumber ?? '–', amount: format(previous.amountOre) })}
    {' '}{t(previous.adjustmentOre === 0 ? 'contractReplacement.paidUnchanged' : previous.adjustmentOre > 0 ? 'contractReplacement.paidIncrease' : 'contractReplacement.paidDecrease', { amount: format(Math.abs(previous.adjustmentOre)) })}
  </div>;
}
